import { Link } from 'react-router-dom';
import { siteInfo, footerLinks } from '@/mocks/site';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6">
        <div className="mx-auto max-w-7xl py-14">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <Link to="/" className="text-2xl font-heading font-bold text-background-50 hover:text-primary-400 transition-colors cursor-pointer">
                {siteInfo.name}
              </Link>
              <p className="mt-4 text-sm text-background-400 leading-relaxed">
                {siteInfo.description}
              </p>
              <div className="flex items-center gap-4 mt-5">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-lg"></i>
                </a>
                <a href={`http://sxthpxzx.cn/q/${siteInfo.qqGroupNumber}`} target="_blank" rel="nofollow noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="QQ">
                  <i className="ri-qq-line text-lg"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 uppercase tracking-wider mb-5">
                热门分类
              </h4>
              <ul className="space-y-3">
                {footerLinks.categories.map((link) => (
                  <li key={link.href}>
                    <Link
                      to={link.href}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 uppercase tracking-wider mb-5">
                关于
              </h4>
              <ul className="space-y-3">
                {footerLinks.about.map((link) => (
                  <li key={link.href}>
                    <Link
                      to={link.href}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 uppercase tracking-wider mb-5">
                法律声明
              </h4>
              <ul className="space-y-3">
                {footerLinks.legal.map((link) => (
                  <li key={link.href}>
                    <Link
                      to={link.href}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
              <div className="mt-5 pt-5 border-t border-background-800">
                <p className="text-xs text-background-500">
                  联系邮箱：{siteInfo.email}
                </p>
                <p className="text-xs text-background-500 mt-1">
                  QQ群号：{siteInfo.qqGroupNumber}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-background-800 py-6">
          <div className="mx-auto max-w-7xl flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有 | 本站内容仅供娱乐参考，请理性吃瓜
            </p>
            <div className="flex items-center gap-3 text-xs text-background-500">
              <Link to="/terms" className="hover:text-primary-400 transition-colors cursor-pointer">用户协议</Link>
              <span>|</span>
              <Link to="/privacy" className="hover:text-primary-400 transition-colors cursor-pointer">隐私政策</Link>
              <span>|</span>
              <Link to="/disclaimer" className="hover:text-primary-400 transition-colors cursor-pointer">免责声明</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}